import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.109 5.39a1.135 1.135 0 0 1 0-1.606L7.09.803a1.135 1.135 0 0 1 1.605 0l2.982 2.98A1.135 1.135 0 0 1 10.07 5.39L9.028 4.346v9.834a1.135 1.135 0 0 1-2.27 0V4.346L5.713 5.389a1.135 1.135 0 0 1-1.605 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }